import React from 'react';
import i18next from 'i18next';

import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import en from './i18n/en';
import it from './i18n/it';

const RecycleBinPage = lazyRetry(() => import('./RecycleBinPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ authorizer }) => authorizer.can('view', 'recyclebin'),
	routes: [
		{
			path: 'recycle-bin',
			element: <RecycleBinPage />
		}
	]
};

export default routes;
